import { render, staticRenderFns } from "./ConfirmDialogue.vue?vue&type=template&id=2fef2352&scoped=true&"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDialogue.vue?vue&type=style&index=0&id=2fef2352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef2352",
  null
  
)

export default component.exports